import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { SearchSelectOption } from '@/components/common/FormDialog';
import { useDebounce } from '@/hooks/useDebounce';
import { OPTION_DETAIL_SEPARATOR } from '@/utils/filters';
import { sourceInstitutesQueryOptions } from '../api/marketPromotion.api';
import type { MpApprovalRow, SourceInstitute } from '../types/marketPromotion.types';

function toSourceInstituteOption(institute: SourceInstitute): SearchSelectOption {
  return {
    value: institute.instituteCode,
    label: institute.instituteName,
    description: [
      String(institute.instituteCode),
      institute.instituteEiin,
      institute.thanaName,
      institute.districtName,
      institute.divisionName,
    ]
      .filter(Boolean)
      .join(OPTION_DETAIL_SEPARATOR),
  };
}

function getSavedSourceOption(donation: MpApprovalRow): SearchSelectOption | undefined {
  if (donation.sourceOfFund === null) return undefined;
  return {
    value: donation.sourceOfFund,
    label: donation.sourceName ?? String(donation.sourceOfFund),
    description: String(donation.sourceOfFund),
  };
}

export function useSourceInstituteOptions(donation: MpApprovalRow) {
  const [query, setQuery] = useState('');
  const search = useDebounce(query.trim());
  const { data, isFetching } = useQuery(sourceInstitutesQueryOptions(search));

  return {
    options: (data ?? []).map(toSourceInstituteOption),
    savedOption: getSavedSourceOption(donation),
    onSearchChange: setQuery,
    isSearching: isFetching,
  };
}
